<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="15"
    :viewBox="`0 0 24 15`"
    :style="{ transform: `rotate(${rotation}deg)` }"
    class="transition-all w-4 h-auto"
    :class="colourOfIconClass"
  >
    <path
      d="M24 0.00149822H21.4545L12 9.4545L2.5455 -3.8147e-06H0V2.547L12 14.547L24 2.547V0.00149822Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import type { ChevronProps } from '~/types';

const props = withDefaults(defineProps<ChevronProps>(), {
  direction: 'right',
  disabled: false,
  severity: 'light',
});

// Rotation based on direction (assuming your SVG points right by default)
const rotationMap = {
  right: -90,
  down: 0,
  left: 90,
  up: -180,
};

// Color based on severity and disabled state
const colourOfIconClass = computed(() => {
  if (props.disabled) {
    return props.severity === 'dark' ? 'text-surface-200' : 'text-surface-500';
  }

  if (props.colour) return props.colour;

  return props.severity === 'dark'
    ? 'text-mbzuai-sand-500'
    : 'text-mbzuai-navy-500';
});

const rotation = computed(() => rotationMap[props.direction]);
</script>
